// covered-by: frontends/carrie/src/ask-v2/rail/__tests__/groupRailCitations.test.ts
// covered-by: frontends/carrie/src/components/ask-puntt-review/__tests__/claimCitations.test.ts

/**
 * Warhol graph node id prefixes, as `store/graph/types.py::node_id` writes them.
 *
 * One home, because two surfaces read the SAME wire format for two different
 * answers and each had declared its own copy: `ask-v2/rail/groupRailCitations.ts`
 * groups an answer's citations by the node an edge comes FROM, while
 * `components/ask-puntt-review/claimCitations.ts` maps the claim an edge points
 * AT back to the chat or memory that cited it. Different questions, one
 * vocabulary -- and a prefix that drifted on one side would send that surface's
 * links somewhere the other's still worked.
 *
 * Deliberately only the prefixes. The two readers keep their own traversals:
 * collapsing them would make the rail's grouping depend on the comment body's
 * provenance map, and neither is a superset of the other.
 *
 * Here in `utils/` rather than in either caller because ask-v2 may not import
 * V1 Ask Puntt (`no-restricted-imports`), so neither side could own it.
 */

/** A conversation. The id after the prefix is the chat's own, ready to link with. */
export const CHAT_NODE = "chat:";

/**
 * A recorded memory. The id after the prefix is the memory's GRAPH node id, not
 * the Mongo `_id` the memories API exposes — a key, never a link target.
 */
export const MEMORY_NODE = "memory:";

/**
 * A past review finding. The id after the prefix is `<ticketId>:<commentId>`,
 * so the ticket it was raised on is linkable.
 */
export const FINDING_NODE = "finding:";

/** A registry rule. The id after the prefix is the Knowledge Database rule id. */
export const CLAIM_NODE = "claim:";
